import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CustomerModel }        from './models/customer';
import { StreamSearchService }  from '../api/stream-search.service';
import { TextControlComponent } from '../shared/controls/text-control/text-control.component';

@Component({
  host       : { class: 'autocomplete' },
  selector   : 'customer-search-control',
  styles: [ require('./customer.search-control.component.scss') ],
  template: require('./customer.search-control.component.html')
})
export class CustomerSearchControlComponent extends TextControlComponent {
  @Input() placement: string;

  @Input() set model ( _model : string | CustomerModel ) {
    this._model = _model;
  }

  @Output() onSelect: EventEmitter<CustomerModel> = new EventEmitter();

  constructor (
    private streamSearchService: StreamSearchService
  ) {
    super();
  }

  format = ( customer : string | CustomerModel ) : string => {
    return typeof customer === 'object' && customer
      ? customer.display_name
      : customer as string || '';
  }

  search = ( typed : string ) : Promise<Array<CustomerModel>> => {
    return this.streamSearchService.search('customers', typed) as unknown as Promise<Array<CustomerModel>>;
  }
}
